var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.061,
    height: 25.065,
    viewBox: "0 0 25.061 25.065",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8073",
    "data-name": "Group 8073",
    transform: "translate(-533.5 -438.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9988",
    "data-name": "Rectangle 9988",
    width: 25.061,
    height: 25.065,
    rx: 2,
    transform: "translate(533.5 438.401)",
    fill: "#e5eaed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock-fill",
    transform: "translate(538.563 443.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M2.5,9A1.911,1.911,0,0,1,4.306,7h6.323a1.911,1.911,0,0,1,1.806,2v5a1.911,1.911,0,0,1-1.806,2H4.306A1.911,1.911,0,0,1,2.5,14Z",
    transform: "translate(0 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M4.5,4A3.267,3.267,0,0,1,7.468.5,3.267,3.267,0,0,1,10.435,4V7H9.588V4a2.334,2.334,0,0,0-2.12-2.5A2.334,2.334,0,0,0,5.348,4V7H4.5Z",
    fillRule: "evenodd"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockFill);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS4wNjEiIGhlaWdodD0iMjUuMDY1IiB2aWV3Qm94PSIwIDAgMjUuMDYxIDI1LjA2NSI+CiAgPGcgaWQ9Ikdyb3VwXzgwNzMiIGRhdGEtbmFtZT0iR3JvdXAgODA3MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUzMy41IC00MzguNDAxKSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzk5ODgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDk5ODgiIHdpZHRoPSIyNS4wNjEiIGhlaWdodD0iMjUuMDY1IiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTMzLjUgNDM4LjQwMSkiIGZpbGw9IiNlNWVhZWQiLz4KICAgIDxnIGlkPSJsb2NrLWZpbGwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUzOC41NjMgNDQzLjQzNCkiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMDIwIiBkYXRhLW5hbWU9IlBhdGggMTAyMCIgZD0iTTIuNSw5QTEuOTExLDEuOTExLDAsMCwxLDQuMzA2LDdoNi4zMjNhMS45MTEsMS45MTEsMCwwLDEsMS44MDYsMnY1YTEuOTExLDEuOTExLDAsMCwxLTEuODA2LDJINC4zMDZBMS45MTEsMS45MTEsMCwwLDEsMi41LDE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMS41KSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMDIxIiBkYXRhLW5hbWU9IlBhdGggMTAyMSIgZD0iTTQuNSw0QTMuMjY3LDMuMjY3LDAsMCwxLDcuNDY4LjUsMy4yNjcsMy4yNjcsMCwwLDEsMTAuNDM1LDRWN0g5LjU4OFY0YTIuMzM0LDIuMzM0LDAsMCwwLTIuMTItMi41QTIuMzM0LDIuMzM0LDAsMCwwLDUuMzQ4LDRWN0g0LjVaIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";